<h2 mat-dialog-title class="dialog-header">
    <div class="dialog-title-block">
        <span class="dialog-overline">{{'finance.payment.details.title'|traduccion}}</span>
        <div class="dialog-title-row">
            <div>
                <div class="dialog-title">{{ payment?.uuid || data?.paymentUuid }}</div>
                <div class="dialog-subtitle" *ngIf="paymentOrderUuid">
                    Order UUID: {{ paymentOrderUuid }}
                </div>
                <div class="dialog-subtitle">Detalle de cobro, carrito, ticket e invoice asociado.</div>
            </div>
            <div class="header-chips" *ngIf="payment">
                <mat-chip-list class="chips">
                    <mat-chip [ngClass]="statusClass(payment?.status)" selectable="false">{{ payment?.status }}</mat-chip>
                    <mat-chip *ngIf="payment?.type">{{ payment?.type }}</mat-chip>
                    <mat-chip *ngIf="payment?.mode">{{ payment?.mode }}</mat-chip>
                </mat-chip-list>
            </div>
        </div>
    </div>
    <button mat-icon-button class="close-btn" (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="dialog-content">

    <div class="page">

        <!-- ===== Datos del pago ===== -->
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>{{'finance.payment.details.data.title'|traduccion}}</mat-card-title>
                <mat-chip-list class="chips">
                    <mat-chip [ngClass]="statusClass(payment?.status)" selectable="false">{{ payment?.status }}</mat-chip>
                    <mat-chip>{{ payment?.type }}</mat-chip>
                    <mat-chip>{{ payment?.mode }}</mat-chip>
                </mat-chip-list>
            </mat-card-header>
            <mat-divider></mat-divider>

            <mat-card-content class="grid grid-2">
                <div class="info-list">
                    <div class="row"><span class="label">{{'finance.payment.details.data.uuid'|traduccion}}</span> <span class="value mono">{{ payment?.uuid }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.data.ticketNumber'|traduccion}}</span> <span class="value">{{ payment?.ticketNumber }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.data.panCard'|traduccion}}</span> <span class="value">{{ payment?.panCard || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.data.invoiceNumber'|traduccion}}</span> <span class="value">{{ payment?.invoice?.invoiceNumber || '—' }}</span></div>
                </div>

                <div class="amounts">
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.details.data.basePrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.basePrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.details.data.taxPrice'|traduccion}} ({{ (payment?.tax ?? 0) * 100 | number:'1.0-0' }}%)</div>
                        <div class="amount-value">{{ payment?.taxPrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount total">
                        <div class="amount-label">{{'finance.payment.details.data.totalPrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.totalPrice | currency:'EUR' }}</div>
                    </div>
                </div>
            </mat-card-content>

            <mat-card-actions align="end" class="gap">
                <button mat-stroked-button (click)="copy(payment?.ticketNumber)">
                    <mat-icon>content_copy</mat-icon> {{'finance.payment.details.data.copyTicket'|traduccion}}
                </button>
                <button mat-stroked-button (click)="downloadTicket(payment?.uuid, payment.ticketNumber)">
                    <mat-icon>download</mat-icon> {{'finance.payment.details.data.downloadTicket'|traduccion}}
                </button>
                 <button *ngIf="payment?.invoice" mat-stroked-button (click)="downloadInvoice(payment?.invoice?.invoiceNumber)">
                    <mat-icon>download</mat-icon> {{'finance.payment.details.data.downloadInvoice'|traduccion}}
                </button>
                <button mat-raised-button color="primary" (click)="generateInvoice()"
                    [disabled]="!!payment?.invoice || payment?.status !== 'CAPTURE'">
                    <mat-icon>request_quote</mat-icon>
                    {{ payment?.invoice ? ('finance.payment.details.data.generateInvoice'|traduccion) : ('finance.payment.details.data.generatedInvoice'|traduccion) }}
                </button>
            </mat-card-actions>
        </mat-card>

        <!-- ===== Datos de la devolución ===== -->
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>{{'finance.payment.refund.details.data.title'|traduccion}}</mat-card-title>
                <mat-chip-list class="chips">
                    <mat-chip [ngClass]="refundStatusClass(payment?.refund?.status)" selectable="false">{{ payment?.refund?.status }}</mat-chip>
                </mat-chip-list>
            </mat-card-header>
            <mat-divider></mat-divider>

            <mat-card-content class="grid grid-2">
                <div class="info-list">
                    <div class="row"><span class="label">{{'finance.payment.refund.details.data.uuid'|traduccion}}</span> <span class="value mono">{{ payment?.refund?.uuid }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.refund.details.data.ticketNumber'|traduccion}}</span> <span class="value">{{ payment?.refund?.ticketNumber }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.refund.details.data.invoiceNumber'|traduccion}}</span> <span class="value">{{ payment?.refund?.invoice?.invoiceNumber || '—' }}</span></div>
                </div>

                <div class="amounts">
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.refund.details.data.basePrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.refund?.basePrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.refund.details.data.taxPrice'|traduccion}} ({{ (payment?.refund?.tax ?? 0) * 100 | number:'1.0-0' }}%)</div>
                        <div class="amount-value">{{ payment?.refund?.taxPrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount total">
                        <div class="amount-label">{{'finance.payment.refund.details.data.totalPrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.refund?.totalPrice | currency:'EUR' }}</div>
                    </div>
                </div>
            </mat-card-content>

            <mat-card-actions align="end" class="gap">
                <button mat-stroked-button (click)="copy(payment?.refund?.ticketNumber)"
                    [disabled]="!payment?.refund?.ticketNumber" >
                    <mat-icon>content_copy</mat-icon> {{'finance.payment.details.data.copyTicket'|traduccion}}
                </button>
                <button mat-stroked-button (click)="downloadTicket(payment?.refund?.uuid, payment?.refund?.ticketNumber)"
                    [disabled]="!payment?.refund?.ticketNumber" >
                    <mat-icon>download</mat-icon> {{'finance.payment.details.data.downloadTicket'|traduccion}}
                </button>
                 <button *ngIf="payment?.refund?.invoice" mat-stroked-button (click)="downloadInvoice(payment.refund?.invoice.invoiceNumber)" >
                    <mat-icon>download</mat-icon> {{'finance.payment.details.data.downloadInvoice'|traduccion}}
                </button>
                <button mat-raised-button color="primary" (click)="generateInvoice()"
                    [disabled]="!payment?.invoice || !payment?.refund?.invoice">
                    <mat-icon>request_quote</mat-icon>
                    {{ payment?.refund?.invoice ? ('finance.payment.details.data.generateInvoice'|traduccion) : ('finance.payment.details.data.generatedInvoice'|traduccion) }}
                </button>
            </mat-card-actions>
        </mat-card>

        <!-- ===== Datos del ticket + Reservas (servicios) ===== -->
        <mat-card class="card">
            <mat-card-header>
                <mat-card-title>{{'finance.payment.details.dataTicket.title'|traduccion}}</mat-card-title>
            </mat-card-header>
            <mat-divider></mat-divider>

            <mat-card-content class="grid grid-2">
                <div class="info-list">
                    <div class="row"><span class="label">{{'finance.payment.details.dataTicket.companyName'|traduccion}}</span> <span class="value">{{ payment?.dataTicket?.companyName }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.dataTicket.companyNif'|traduccion}}</span> <span class="value">{{ payment?.dataTicket?.companyNif }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.dataTicket.companyAddress'|traduccion}}</span> <span class="value">{{ payment?.dataTicket?.companyAddress }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.dataTicket.date'|traduccion}}</span> <span class="value">{{ payment?.dataTicket?.date }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.dataTicket.ticketNumber'|traduccion}}</span><span class="value mono">{{ payment?.dataTicket?.uuid }}</span></div>
                </div>

                <div class="ticket-totals">
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.details.dataTicket.basePrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.basePrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount">
                        <div class="amount-label">{{'finance.payment.details.dataTicket.taxPrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.taxPrice | currency:'EUR' }}</div>
                    </div>
                    <div class="amount total">
                        <div class="amount-label">{{'finance.payment.details.dataTicket.totalPrice'|traduccion}}</div>
                        <div class="amount-value">{{ payment?.totalPrice | currency:'EUR' }}</div>
                    </div>
                </div>
            </mat-card-content>

            <div class="section-title">{{'finance.payment.details.reserve.title'|traduccion}}</div>
            <div class="table-wrap">
                <app-data-table
                    class="payment-reservations-desktop-view"
                    preset="modal"
                    [dataSource]="reservationsDS"
                    [displayedColumns]="reservationCols"
                    tableClass="w-full"
                    emptyIcon="inbox"
                    [emptyMessage]="'finance.payment.details.reserve.nodate'|traduccion">

                    <ng-container matColumnDef="name">
                        <th mat-header-cell *matHeaderCellDef class="sticky">{{'finance.payment.details.reserve.header.name'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">
                            <div class="name">{{ r.name }}</div>
                            <div class="muted mono" *ngIf="r.reference">Ref: {{ r.reference }}</div>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="amount">
                        <th mat-header-cell *matHeaderCellDef class="sticky">{{'finance.payment.details.reserve.header.amount'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.amount }}</td>
                    </ng-container>

                    <ng-container matColumnDef="basePrice">
                        <th mat-header-cell *matHeaderCellDef class="sticky">{{'finance.payment.details.reserve.header.basePrice'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.basePrice | currency:'EUR' }}</td>
                    </ng-container>

                    <ng-container matColumnDef="tax">
                        <th mat-header-cell *matHeaderCellDef class="sticky">{{'finance.payment.details.reserve.header.tax'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.tax }}</td>
                    </ng-container>

                    <ng-container matColumnDef="total">
                        <th mat-header-cell *matHeaderCellDef class="sticky">{{'finance.payment.details.reserve.header.total'|traduccion}}</th>
                        <td mat-cell *matCellDef="let r">{{ r.total | currency:'EUR' }}</td>
                    </ng-container>

                </app-data-table>

                <div class="payment-reservations-mobile-view" *ngIf="reservationsDS.data?.length; else noPaymentReservationsMobile">
                    <article class="payment-reservation-mobile-card" *ngFor="let r of reservationsDS.data">
                        <div class="payment-reservation-mobile-row">
                            <div>
                                <strong class="payment-reservation-mobile-title">{{ r.name }}</strong>
                                <span class="muted mono" *ngIf="r.reference">Ref: {{ r.reference }}</span>
                            </div>
                        </div>
                        <div class="payment-reservation-mobile-grid">
                            <div class="payment-reservation-mobile-item">
                                <span class="payment-reservation-mobile-label">{{'finance.payment.details.reserve.header.amount'|traduccion}}</span>
                                <strong>{{ r.amount }}</strong>
                            </div>
                            <div class="payment-reservation-mobile-item">
                                <span class="payment-reservation-mobile-label">{{'finance.payment.details.reserve.header.basePrice'|traduccion}}</span>
                                <strong>{{ r.basePrice | currency:'EUR' }}</strong>
                            </div>
                            <div class="payment-reservation-mobile-item">
                                <span class="payment-reservation-mobile-label">{{'finance.payment.details.reserve.header.tax'|traduccion}}</span>
                                <strong>{{ r.tax }}</strong>
                            </div>
                            <div class="payment-reservation-mobile-item">
                                <span class="payment-reservation-mobile-label">{{'finance.payment.details.reserve.header.total'|traduccion}}</span>
                                <strong>{{ r.total | currency:'EUR' }}</strong>
                            </div>
                        </div>
                    </article>
                </div>

                <ng-template #noPaymentReservationsMobile>
                    <div class="payment-reservations-mobile-empty">
                        {{'finance.payment.details.reserve.nodate'|traduccion}}
                    </div>
                </ng-template>
            </div>
        </mat-card>

        <!-- ===== Carrito (userData) + Cliente asignado ===== -->
        <div class="grid grid-2">
            <mat-card class="card">
                <mat-card-header><mat-card-title>{{'finance.payment.details.card.title'|traduccion}}</mat-card-title></mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content class="info-list">
                    <div class="row"><span class="label">{{'finance.payment.details.card.title'|traduccion}}</span> <span class="value">{{'—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.card.email'|traduccion}}</span> <span class="value">{{ payment?.cart?.userData?.email || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.card.telephoneNumber'|traduccion}}</span> <span class="value">{{ payment?.cart?.userData?.telephoneNumber || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.card.langCode'|traduccion}}</span> <span class="value">{{ payment?.cart?.userData?.langCode || '—' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.card.discountCode'|traduccion}}</span><span class="value">{{ payment?.cart?.userData?.discountCode || 'No aplicado' }}</span></div>
                    <div class="row"><span class="label">{{'finance.payment.details.card.insurance'|traduccion}}</span> <span class="value">{{ payment?.cart?.userData?.insurance ? 'Sí' : 'No' }}</span></div>
                </mat-card-content>
            </mat-card>

            <mat-card class="card">
                <mat-card-header><mat-card-title>{{'finance.payment.details.client.title'|traduccion}}</mat-card-title></mat-card-header>
                <mat-divider></mat-divider>
                <mat-card-content>
                    <div class="assigned">
                        <mat-icon>person</mat-icon>
                        <div class="assigned-info">
                            <div class="assigned-name">{{ payment?.userFiscalData?.cardId || ('finance.payment.details.client.unassined'|traduccion) }}</div>
                            <div class="muted">{{ payment?.userFiscalData?.email || '—' }}</div>
                        </div>
                        <span class="spacer"></span>
                        <button mat-raised-button color="primary" (click)="openAssignDialog()">
                            {{ (payment?.userFiscalData) ? ('finance.payment.details.client.change'|traduccion) : ('finance.payment.details.client.assing'|traduccion) }}
                        </button>
                    </div>
                </mat-card-content>
            </mat-card>
        </div>

    </div>


</mat-dialog-content>
